import { FormEventHandler } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ConventionalSelect } from '@vst/beam';
import { useTranslation } from 'react-i18next';

import { selectHasFiber, selectIsPreinstall } from '@app/redux';
import { selectSurveyValues, setSurveyValues } from '@app/redux/disconnect';

const NewProvider = ({ providerOptions }: { providerOptions: string }) => {
  const dispatch = useDispatch();
  const { t } = useTranslation('Disconnect');
  const surveyValues = useSelector(selectSurveyValues);
  const hasPreinstall = useSelector(selectIsPreinstall);
  const hasFiber = useSelector(selectHasFiber);

  const options = Object.values(providerOptions).map((key: string) => ({
    label: key,
    value: key,
    id: key,
  }));

  const handleProviderSelection: FormEventHandler<HTMLInputElement> = (e) => {
    const target = e.target as HTMLInputElement;
    const provider = target.value;
    dispatch(setSurveyValues({ provider }));
  };

  const preinstallLabel = hasFiber
    ? t('survey.fiber.preinstall.provider.label')
    : t('survey.satellite.preinstall.provider.label');

  const activeLabel = hasFiber ? t('survey.fiber.active.provider.label') : t('survey.satellite.active.provider.label');

  const labelText = hasPreinstall ? preinstallLabel : activeLabel;

  return (
    <ConventionalSelect
      id="providers"
      name="providers"
      fluid
      labelProps={{ labelText }}
      options={options}
      onChange={handleProviderSelection}
      value={surveyValues.provider}
    />
  );
};

export default NewProvider;
